import { render, staticRenderFns } from "./H5HorizontalNewsVideoList.vue?vue&type=template&id=4a39be13&scoped=true"
import script from "./H5HorizontalNewsVideoList.vue?vue&type=script&lang=js"
export * from "./H5HorizontalNewsVideoList.vue?vue&type=script&lang=js"
import style0 from "./H5HorizontalNewsVideoList.vue?vue&type=style&index=0&id=4a39be13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39be13",
  null
  
)

export default component.exports